import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type Header } from '@tanstack/react-table';
import classNames from 'classnames';

import { ResetIcon } from '../../../../assets';
import { FilterContent } from '../FilterButton/FilterContent';

import styles from './FilterCell.module.scss';

export interface IFilterCellProps {
    header: Header<any, unknown>;
    last?: boolean;
}

export const FilterCell: React.FC<IFilterCellProps> = ({ header, last }) => {
    const { t } = useTranslation();
    const filter = header.column.columnDef.meta?.filtering;
    const canFilter = header.column.getCanFilter() !== false && filter !== undefined;

    const columnWidth = useMemo(() => {
        if (header.column.columnDef.size || header.column.getCanResize()) {
            return header.getSize();
        }
        return 'auto';
    }, [header.column.columnDef.size, header.getSize(), header.column.getCanResize()]);

    return (
        <th
            colSpan={header.colSpan}
            className={classNames(styles.filterCell, {
                [styles.last]: !!last,
            })}
            style={{ width: columnWidth }}
        >
            {canFilter && (
                <>
                    <div className={styles.filterContent}>
                        <FilterContent header={header} inline />
                    </div>
                    <button
                        aria-label={`${t('table.filtering.reset')}: ${
                            typeof header.column.columnDef.header === 'string'
                                ? header.column.columnDef.header
                                : header.column.id
                        }`}
                        className={styles.resetButton}
                        data-role="inline-filter-reset"
                        onClick={() => header.column.setFilterValue(null)}
                        type="button"
                    >
                        <ResetIcon className={styles.resetIcon} />
                        {t('table.filtering.reset')}
                    </button>
                </>
            )}
        </th>
    );
};
